'use strict';

bbw.service.UserSettingsSvc = Class({

    statics: {
        groups: {
            privacy: {
                hide_from_search: false,
                deny_users_without_photo: false,
                allow_send_private_photo: false
            },
            controls: {
                open_links_in_new_window: true,
                chat_ctrl_enter: false
            },
            notifications: {
                notify_new_messages: true,
                notify_new_users: true,
                notify_bulk_messages: true
            }
        },
        forEachGroup: function(fn) {
            Object.keys(bbw.service.UserSettingsSvc.groups).forEach(fn);
        }
    },

    $inject: ['modelFactory'],

    /**
     * @type {bbw.model.UserSettings}
     */
    _userSettingsModel: undefined,

    /**
     * @param {ngtk.model.Factory} modelFactory
     */
    construct: function(modelFactory) {
        this._userSettingsModel = modelFactory.create(bbw.model.UserSettings);
    },

    forEachGroup: function(fn) {
        bbw.service.UserSettingsSvc.forEachGroup(fn);
    },

    load: function() {
        return this._userSettingsModel.load();
    },

    wireScope: function() {
        this._userSettingsModel.wireScope.apply(this._userSettingsModel.wireScope, arguments);
        return this;
    },

    get: function(key) {
        return this._userSettingsModel.get(key);
    },

    getGroup: function(groupName) {
        var groupFields = bbw.service.UserSettingsSvc.groups[groupName];
        if (!angular.isObject(groupFields)) {
            throw new Error("Invalid argument: unknown group name [" + groupName + "]");
        }
        return new bbw.model.UserSettingsGroup(groupName, groupFields, this._userSettingsModel.exportData());
    },

    /**
     * @param {bbw.model.UserSettingsGroup} group
     */
    updateGroup: function(group) {
        return this.update(group.getValues());
    },

    update: function(newSettings) {
        return this._userSettingsModel.update(newSettings);
    }

});
